import { render, staticRenderFns } from "./ButtonPlain.vue?vue&type=template&id=5f6e5008&scoped=true&"
import script from "./ButtonPlain.vue?vue&type=script&lang=js&"
export * from "./ButtonPlain.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPlain.vue?vue&type=style&index=0&id=5f6e5008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e5008",
  null
  
)

export default component.exports